import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export const ModalContainer = ({ children, isLoading }) => {
  return (
    <div className={classnames('subscription-modal', { 'subscription-modal--loading': isLoading })}>
      {React.Children.map(children, child => child)}
    </div>
  );
};

ModalContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isLoading: PropTypes.bool,
};
